module.exports = __webpack_public_path__ + "static/media/s1-no-va.e28908a6.png";